/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.repository.cauce

import kotlinx.coroutines.flow.Flow
import studio.oddpods.cauce.core.model.reminder.PendingReminder

data class ReminderSentEntry(val sessionId: String, val reminderNumber: Int)

interface ReminderRepository {
    /** Hot flow of grouped pending reminders. Auto-fetches on first collect. */
    fun getPendingReminders(): Flow<List<PendingReminder>>

    /** Refresh from server. */
    suspend fun refresh(): Result<Unit>

    /** Idempotent batch insert. Returns number of rows actually inserted. */
    suspend fun recordBatchSent(entries: List<ReminderSentEntry>): Result<Int>

    /** Convenience: count of due sessions across all pending reminders. */
    fun getPendingCount(): Flow<Int>
}
